export default __webpack_public_path__ + "static/media/saunatimeFacebook-1200x630.16d66ac9.jpg";